export enum ENV_LIST {
    LOCAL = 'local',
    STAGING = 'staging',
    REVIEW_APP = 'review_app',
    DEMO_01 = 'demo01',
    SANDBOX = 'sandbox',
    PRODUCTION = 'production',
}

export enum AvailableToggleFeatures {
    welcome_page = 'welcome_page',
}

const featuresByEnv = Object.freeze({
    // Usage example:
    // [ENV_LIST.LOCAL]: [AvailableToggleFeatures.ma_feature]
    [ENV_LIST.LOCAL]: [AvailableToggleFeatures.welcome_page],
    [ENV_LIST.STAGING]: [AvailableToggleFeatures.welcome_page],
    [ENV_LIST.REVIEW_APP]: [AvailableToggleFeatures.welcome_page],
    [ENV_LIST.DEMO_01]: [AvailableToggleFeatures.welcome_page],
    [ENV_LIST.SANDBOX]: [AvailableToggleFeatures.welcome_page],
    [ENV_LIST.PRODUCTION]: [AvailableToggleFeatures.welcome_page],
});

export function getEnabledFeaturesByEnv(envName: ENV_LIST) {
    return featuresByEnv?.[envName];
}
